import dm1 from '../../assets/dataModel/dm_main.png';
import Image from 'next/image';
import { motion } from 'framer-motion';
import Link from 'next/link';
import agronomy from '../../assets/research/argonomy.png';
import climate from '../../assets/research/climate.png';
import hardware from '../../assets/research/hardware.png';
import machine from '../../assets/research/machine.png';
import satellite_image from '../../assets/research/satellite_image.png';
import MetaHead from '@/Components/MetaHead';

import MainHeading from '@/Components/MainHeading';
import SubHeading from '@/Components/SubHeading';

const ResearchData = [
  {
    title: 'Agronomy',
    content: [
      'We have researched and worked on 20+  crops across horticulture, plantation , fibres and agriculture. We have 100+ models for precise irrigation, fertigation and disease and pest models. Our models have an average R2 value of 0.93.',
      'Our research includes devising accurate stagewise irrigation schedules, understanding of nutrient interactions in crops and understanding the entomology of various pests and pathogens that may attack the crops. We provide alerts and actionable insights to protect crop just in the right time.',
      'We have researchers in soil science, plant physiology, plant pathology, entomology and crop nutrition.',
    ],
    images: agronomy,
    link: '/crop',
  },
  {
    title: 'Hardware',
    content: [
      'We have been working on highly efficient , accurate and high quality IoT devices. These devices collect data from the farms at a regular interval. Our devices are patented and meet the global standards for accuracy and safety.',
    ],
    images: hardware,
    link: '/product/hardware',
  },
  {
    title: 'Climate Research',
    content: [
      'We study the microclimate around crops to predict the weather patterns at microclimate level. We have hourly and daily weather models. Our climate research includes ',
      ' We have 30+ weather models with 50% more accuracy compared to global weather models like GFS and ECMWF.',
    ],
    images: climate,
    link: '/about/weather-model',
  },
  {
    title: 'Machine Learning and Satellite Data',
    content: [
      'Our machine learning research includes predicting weather, finding patterns in farm activities, disease & pest predictions and analysing satellite images for parameters like yield prediction, leaf area index and NDVI. We continuously analyse farm data using our proprietary machine learning models to extract insights out of the raw data. We also predict soil moisture in macro level using satellite data.        ',
    ],
    images: machine,
    link: '/product/software/#Dashboard',
  },
];

export default function Research() {
  return (
    <main className="max-w-screen-xl mx-auto">
      <MetaHead title="Research | Fyllo" />
      <div>
        <div className="mx-auto max-w-screen-sm">
          <MainHeading text="Research" />
          <SubHeading text="In-Depth Analysis and Experimentation to Improve Crop Yield and Sustainability" />
        </div>
      </div>
      <div className="w-full flex flex-col gap-1 scroll-smooth snap-y snap-mandatory ">
        {ResearchData.map((point, i) => {
          return (
            <div key={i}>
              <div
                className={
                  ' border-black  md:h-[70vh] w-full flex items-center rounded-lg p-2  px-5 flex-col snap-always snap-center md:gap-32  ' +
                  (i % 2 === 1 ? 'md:flex-row ' : 'md:flex-row-reverse')
                }
              >
                <div className={' w-full md:w-1/2 h-auto md:p-4 leading-normal text-start flex flex-col items-left  '}>
                  <motion.h2
                    initial={{
                      y: -100,
                      scale: 1.5,
                      opacity: 0.7,
                    }}
                    whileInView={{
                      y: 0,
                      scale: 1,
                      opacity: 1,
                      transition: {
                        delay: 0.2,
                        duration: 2,
                        type: 'linear',
                      },
                    }}
                    transition={{
                      type: 'linear',
                    }}
                    viewport={{ once: true }}
                    className="text-left mb-2 md:mb-6 text-xl md:text-4xl font-semibold tracking-tight text-green-800"
                  >
                    {point.title}
                  </motion.h2>
                  <motion.div
                    initial={{
                      y: -100,
                      scale: 1,
                      opacity: 0,
                    }}
                    whileInView={{
                      y: 0,
                      scale: 1,
                      opacity: 1,
                      transition: {
                        delay: 0.2,
                        duration: 2,
                        type: 'linear',
                      },
                    }}
                    transition={{
                      type: 'linear',
                    }}
                    viewport={{ once: true }}
                    className={'mb-3 text-xm font-light text-gray-500  md:text-md lg:text-lg  md:text-left'}
                  >
                    <ul className="max-w-lg  text-gray-600 list-inside ">
                      {point.content?.map((it, i) => {
                        return (
                          <li key={i} className="flex items-center">
                            {/* <svg className="w-4 h-4 mr-1.5 full-fyllo-500 flex-shrink-0" fill="#016839" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> */}
                            {it}
                          </li>
                        );
                      })}
                    </ul>
                    <div className="w-full">
                      <Link
                        href={point.link}
                        className="mt-5 inline-flex items-center px-5 py-2 text-sm font-medium text-center text-white bg-green-700 rounded-lg hover:bg-green-900 "
                      >
                        <p className="text-white">Know More</p>
                        <svg
                          aria-hidden="true"
                          className="w-4 h-4 ml-2 -mr-1"
                          fill="white"
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                      </Link>
                    </div>
                  </motion.div>
                </div>

                <motion.div
                  initial={{
                    y: 100,
                  }}
                  whileInView={{
                    y: 0,
                    transition: {
                      duration: 2,
                      type: 'linear',
                    },
                  }}
                  transition={{
                    type: 'linear',
                  }}
                  viewport={{ once: true }}
                  className={
                    'w-full md:w-1/2 flex flex-col items-center   '
                    //   +
                    //   (i % 2 === 0
                    //       ? " md:items-end"
                    //       : " md:items-start")
                  }
                >
                  <Image
                    height={300}
                    width={200}
                    className={'rounded-2xl w-[100%] md:w-[100%] my-5 md:my-0'}
                    src={point.images}
                    alt={point.title}
                    srcSet=""
                    sizes="(max-width: 768px) 100vw,
              (max-width: 1200px) 50vw,
              33vw"
                  />
                </motion.div>
              </div>
            </div>
          );
        })}
      </div>
    </main>
  );
}
